import React, { useState } from 'react';
import '../Styles/menu-mobile.css';
import LinkMenuPrimary from './LinkMenuPrimary';

function MenuMobile() {
  const [isActiveMenu, setIsActiveMenu] = useState(false);

  const toggleMenu = () => {
    setIsActiveMenu(!isActiveMenu);
    document.body.classList.toggle('is-activeMenu', !isActiveMenu);
  };

  const closeMenu = () => {
    setIsActiveMenu(false);
    document.body.classList.remove('is-activeMenu');
  };

  return (
    <>
      <div className="menu-mobile">
        <div className="siteHeader__navToggleWrap" onClick={toggleMenu}>
          <div className={`siteNavToggle ${isActiveMenu ? 'is-active' : ''}`}>
            <div className="siteNavToggle__bar"></div>
          </div>
        </div>
      </div>

      <div id="navlinks-mobile" className={`navLinks-mobile flex-center flex-column flex__gap-100 ${isActiveMenu ? 'show' : ''}`}>
        <nav className="flex-center flex-column flex__gap-30">
          <LinkMenuPrimary idSection='home-section' name='Inicio'  closeMenu={closeMenu}/>
          <LinkMenuPrimary idSection='insta-section' name='Instagram'  closeMenu={closeMenu}/>
          <LinkMenuPrimary idSection='tiktok-section' name='Tiktok'  closeMenu={closeMenu}/>
          <LinkMenuPrimary idSection='awards-section' name='Premiações'  closeMenu={closeMenu}/>
          <LinkMenuPrimary idSection='spotify-section' name='Spotify'  closeMenu={closeMenu}/>
          <LinkMenuPrimary idSection='product-section' name='Loja'  closeMenu={closeMenu}/>
        </nav>
      </div>

      <div className="overlay" style={{ display: isActiveMenu ? 'block' : 'none' }} onClick={closeMenu}></div>
    </>
  );
}

export default MenuMobile;
